import React from 'react';
import { Button } from 'reactstrap';
import { BASE_API_URL } from '../constants';

const CustomerExportButton = () => {
    const handleExport = () => {
    window.open(`${BASE_API_URL}/export/customers/`, '_blank');
    };

    return (
        <Button color="success" onClick={handleExport}>
            Export Customers
        </Button>
    );
};

export default CustomerExportButton;
